import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

const routes = [
  {
    to: '/about',
    text: 'About'
  },
  {
    to: '/work',
    text: 'Work'
  },
  {
    to: '/observatory',
    text: 'Observatory'
  },
  {
    to: '/contact',
    text: 'Contact'
  }
];

// Onclick is applied as a fallback so that if the user presses the active
// route the menu will be closed
const Routes = ({ onClick }) =>
  routes.map(link => {
    const { text, ...props } = link;
    return (
      <Link
        key={text}
        activeClassName="selected"
        partiallyActive
        onClick={onClick}
        {...props}
      >
        {text}
      </Link>
    );
  });

Routes.propTypes = {
  onClick: PropTypes.func
};

export default Routes;
